<template>
    <button
    :cn="componentName"
    v-bind:id="this.id"
    v-bind:class="[disabled ? 'cursor-not-allowed' : '', classObject, css]"
    @click.prevent="click($event)"
    :disabled="disabled"
    >
        <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>

        <!-- <i class="fas fa-spinner fa-spin"></i> -->

        <slot name="label"></slot>

    </button>
</template>

<script>
export default {
    props: {
        id : {
            required : false,
        },
        predefinedStyle : {
            type: String,
            default : "default",
        },
        css: String,
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            predefinedStyles: {
                default: "inline-flex items-center text-white bg-accent-color hover:bg-accent-color font-medium rounded-md text-base items-center px-3 py-1.5",
                transparentLight: "bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-slate-100 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md text-base font-medium px-3 py-1.5",
                transparentLightNoP: "bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-slate-100 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md text-base font-medium px-2 py-1",
                transparent: "bg-transparent dark:bg-gray-700 text-gray-800 dark:text-slate-100 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md text-base font-medium px-3 py-1.5",
                transparentSmall: "bg-transparent text-gray-700 hover:bg-gray-200 dark:hover:bg-slate-500 dark:text-slate-100 rounded-md px-2 py-1 ml-1",
                transparentSmallBordered: "justify-center items-center bg-gray-200 dark:bg-gray-700 text-gray-700 hover:bg-gray-200 dark:hover:bg-slate-500 dark:text-slate-100 rounded-md px-2 py-1 mx-1 rounded-md broder-solid border-gray-300 border-2 hover:border-gray-500 hover:bg-gray-300  dark:hover:bg-gray-600 ",
                red: "text-white bg-red-600 hover:bg-red-800 font-medium rounded-md text-base inline-flex items-center px-3 py-1.5 text-center",
                green: "text-white bg-green-600 hover:bg-green-800 font-medium rounded-md text-base inline-flex items-center px-3 py-1.5 text-center",
                defaultTiny : "inline-flex items-center text-white bg-accent-color hover:bg-accent-color font-medium rounded-md text-base items-center px-1 p-0.5",
                browserTab : "inline-flex items-center text-white hover:bg-gray-300 dark:hover:bg-slate-500 font-medium rounded-md text-base items-center px-1 p-0.5",
                inputTyp: "border-gray-200 dark:border-transparent px-2 dark:hover:border-slate-500 dark:focus-visible:border-slate-500 focus-visible:border-accent-color appearance-none outline-none text-gray-400 w-full bg-white py-1 rounded-md",
                sidemenu: "text-base block py-2 px-4 rounded hover:bg-accblue-100 dark:hover:bg-gray-700 text-white"
            }
        };
    },
    computed: {
    componentName(){
        return "CustomButton";
    },
    classObject: function () {
        if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
            return this.predefinedStyles[this.predefinedStyle];
        }
    }
    },
    methods: {
        click(event) {
            if(this.loading === false){
                this.$emit("button:click", event);
            }
        }
    }
}
</script>
